import React, { Component } from "react"
import styled from "styled-components"
import { Spinner, Container, Modal, Button } from "react-bootstrap"
import Cta from "../components/Cta"

// component for dynamic contact form
class DynamicContactForm extends Component {
  constructor(props) {
    // Required step: always call the parent class' constructor
    super(props)

    // Set the state directly. Use props if necessary.
    this.state = {
      questionnaires: this.props.questionnaires,
      standardFields: this.props.standardFields,
      contactReason: this.props.preselect,
      answers: {
        contactReason: this.props.preselect,
      },
      showModal: false,
      modalTitle: "Standard Titel",
      modalMessage: "Standard Message",
      isLoading: true,
    }
  }
  componentDidMount() {
    // to show the preselected item (passed by queryString)  in the the select component
    this.setState({
      isLoading: false,
    })
  }

  // Form change handler
  handleChange = event => {
    const value =
      event.target.type === "checkbox"
        ? event.target.checked
        : event.target.value
    const currentAnswer = this.state.answers
    currentAnswer[event.target.name] = value
    this.setState({
      answers: currentAnswer,
    })
  }
  // handler to select contact reason
  handleSelect = event => {
    const currentAnswer = this.state.answers
    currentAnswer[event.target.name] = event.target.value

    this.setState({ contactReason: event.target.value, answers: currentAnswer })
    //console.log(this.state.answers)
  }
  // Form validation
  validateForm = event => {
    let privacyCheck = this.state.answers.privacy
    //console.log("privacycheck:", privacyCheck)
    if (!privacyCheck) {
      alert("Bitte bestätige den Datenschutzhinweis")
      event.preventDefault()
      return false
    }
    return true
  }
  // handler to send data to API endpoint / netlify lambda function
  handleSubmit = event => {
    if (!this.validateForm(event)) {
      return
    }
    event.preventDefault()

    // url for post request to send the email
    const url = "/.netlify/functions/sendMail"
    fetch(url, {
      method: "POST",
      body: JSON.stringify(this.state.answers), // body data type must match "Content-Type" header
    })
      .then(response => {
        if (response.status === 200) {
          // display success message on submit
          this.setState({
            modalTitle: "Vielen Dank für deine Nachricht.",
            modalMessage:
              "Deine Nachricht wurde versendet.<br/> Wir melden uns bei dir.",
            showModal: true,
          })
        }
      })
      .catch(err =>
        // display error message
        this.setState({
          modalTitle: "Hoppla!",
          modalMessage:
            "Hier ist etwas schiefgelaufen.<br/> Bitte versuche es erneut.",
          showModal: true,
        })
      )
  }
  // handler to close the modal
  handleClose = () => {
    this.setState({ showModal: false })
    if (typeof window !== "undefined") {
      // if window type is defined
      window.location = "/" // redirect to home page
    }
  }

  render() {
    let selQuestionnaire = this.state?.questionnaires.filter(el => {
      // console.log(el.title, this.state.contactReason)
      return el.title === this.state.contactReason
    })[0]

    // if (!this.state.contactReason) {
    //   return "Loading"
    // }
    // only display the form once page is fully loaded
    if (this.state.isLoading === false) {
      return (
        <>
          <MyForm name="contact" method="POST" onSubmit={this.handleSubmit}>
            <input type="hidden" name="form-name" value="contact" />
            {this.state.questionnaires.length > 0 ? (
              <select // Contact Reasons static input
                className="dropdown"
                name="contactReason"
                id="contact_reason"
                value={this.state.contactReason}
                onChange={this.handleSelect}
              >
                <option value="">Kontaktgrund wählen</option>
                {this.state.questionnaires?.map(element => {
                  return (
                    <option key={element.id} value={element.title}>
                      {element.title}
                    </option>
                  )
                })}
              </select>
            ) : (
              ""
            )}

            {this.state.standardFields?.map(input => {
              switch (input._type) {
                case "normalInput":
                  return (
                    <NormalInput
                      key={input._key}
                      value={this.state[input.name]}
                      onChange={this.handleChange}
                      {...input}
                    />
                  )

                case "selectInput":
                  return (
                    <SelectInput
                      key={input._key}
                      value={this.state[input.name]}
                      onChange={this.handleChange}
                      {...input}
                    />
                  )
                default:
                  break
              }
            })}
            {selQuestionnaire?.inputs.map(input => {
              switch (input._type) {
                case "normalInput":
                  return (
                    <NormalInput
                      key={input._key}
                      value={this.state[input.name]}
                      onChange={this.handleChange}
                      {...input}
                    />
                  )

                case "selectInput":
                  return (
                    <SelectInput
                      key={input._key}
                      value={this.state[input.name]}
                      onChange={this.handleChange}
                      {...input}
                    />
                  )
                default:
                  break
              }
            })}
            {/* Privacy statement checkbox */}
            <input
              type="checkbox"
              id="privacy"
              name="privacy"
              checked={this.state.privacy}
              onChange={this.handleChange}
            />
            <label htmlFor="privacy">
              Ich habe die{" "}
              <a href="/datenschutz" target="_blank" rel="noreferrer noopener">
                Datenschutzhinweise
              </a>{" "}
              gem. Art. 13 DSGVO gelesen.*
            </label>

            <span className="mandatory-info">* Pflichtfeld</span>
            <Cta fullWidth type="submit">
              Senden
            </Cta>
          </MyForm>
          <Modal show={this.state.showModal} onHide={this.handleClose}>
            <MyModalHeader
              closeButton
              style={{ backgroundColor: "#1B2916", color: "white" }}
            >
              <Modal.Title>{this.state.modalTitle}</Modal.Title>
            </MyModalHeader>
            <Modal.Body
              dangerouslySetInnerHTML={{ __html: this.state.modalMessage }}
              style={{ backgroundColor: "#1E442F", color: "white" }}
            ></Modal.Body>
            <Modal.Footer
              style={{ backgroundColor: "#1B2916", color: "white" }}
            >
              <Button variant="secondary" onClick={this.handleClose}>
                Weiter
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      )
    } else {
      return <MySpinner />
    }
  }
}

// wrapper for the spinner
const MySpinnerWrapper = styled.div`
  flex: 0 0 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`
// component for the spinner
const MySpinner = props => {
  return (
    <MySpinnerWrapper>
      <Spinner animation="border" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    </MySpinnerWrapper>
  )
}

// component for normal input fields
const NormalInput = props => {
  // console.log("normal  input", props)
  console.log("Normal input", props)
  // for fields of type "textarea"
  if (props.type === "textarea") {
    return (
      <textarea
        name={props.name}
        id={props.name}
        rows="4"
        value={props.value}
        onChange={props.handleChange}
        placeholder={`${
          props.placeholder ? props.placeholder : props.name.toUpperCase()
        }${props.required ? "*" : ""}`}
      />
    )
  }
  // for fields of type "input"
  return (
    <input
      className="input"
      type={props.type}
      name={props.name}
      id={props.name}
      value={props.value}
      onChange={props.onChange}
      placeholder={`${
        props.placeholder ? props.placeholder : props.name.toUpperCase()
      }${props.required ? "*" : ""}`}
      required={props.required ? "required" : ""}
    />
  )
}

// component for select input fields
const SelectInput = props => {
  // console.log("select  input", props)
  // for fields of type "select"
  if (props.type === "select") {
    return (
      <select
        className="dropdown"
        name={props.name}
        id={`select-${props.name}`}
        value={props.value}
        onChange={props.onChange}
        required={props.required ? "required" : ""}
      >
        <option key={0} value="">
          {props.label || props.name}
        </option>
        {props.options.map((el, index) => {
          // console.log("options", el)
          return (
            <option key={`${el}-${index}`} value={el}>
              {el}
            </option>
          )
        })}
      </select>
    )
  }
  // for fields of type "radio"
  if (props.type === "radio") {
    return (
      <div
        className="radio-container"
        name={props.name}
        value={props.value}
        onChange={props.onChange}
        required={props.required ? "required" : ""}
      >
        {props.label ? (
          <p>
            <strong>{props.label}</strong>
          </p>
        ) : (
          ""
        )}
        {props.options?.map(el => (
          <>
            <input
              className="radio"
              key={`radio-${props.name}-${el}`}
              type="radio"
              id={`radio-${props.name}-${el}`}
              value={el}
              name={props.name}
            />
            <label
              className="radio-label"
              htmlFor={`radio-${props.name}-${el}`}
            >
              {el}
            </label>
          </>
        ))}
      </div>
    )
  }
  // for fields of type "checkbox"
  if (props.type === "checkbox") {
    return (
      <div className="checkbox-container">
        {props.label ? (
          <p>
            <strong>{props.label}</strong>
          </p>
        ) : (
          ""
        )}
        {props.options?.map(el => (
          <>
            <input
              className={`checkbox`}
              key={`checkbox-${props.name}-${el}`}
              type="checkbox"
              name={`${props.name}-${el}`}
              id={`${props.name}-${el}`}
              value={el}
              onChange={props.onChange}
              placeholder={
                props.placehoder ? props.placeholder : props.name.toUpperCase()
              }
              // required={props.required ? "required" : ""}
            />
            <label htmlFor={`${props.name}-${el}`}> {el}</label>
          </>
        ))}
      </div>
    )
  }
}

// component for the modal header
const MyModalHeader = styled(Modal.Header)`
  .close {
    color: #ffffff;
  }
`

// component for the contact form
const MyForm = styled.form`
  flex: 0 0 50%;
  width: 100%;
  margin-left: 30px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  /* mobile styling */
  @media (max-width: ${props => props.theme.mobile}) {
    margin-left: unset;
    margin-top: 15px;
  }
  input,
  textarea,
  select {
    margin-bottom: 10px;
  }
  & textarea {
    width: 100%;
    height: 200px;
    padding-left: 10px;
    padding-top: 10px;
    border: 1px solid #888888;
    border-radius: 3px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: #888888;
    background: #ffffff;
  }
  & .input {
    width: 100%;
    height: 40px;
    padding-left: 10px;
    border: 1px solid #888888;
    border-radius: 3px;

    color: #888888;
    background: #ffffff;
  }

  .checkbox-container,
  radio-container {
    display: flex;
    flex-direction: column;
    background-color: rgba(128, 128, 128, 0.1);
    border-radius: 5px;
    padding-left: 15px;
    margin-bottom: 15px;
  }
  input[type="checkbox"] {
    display: none;
    height: 40px;
  }
  input[type="checkbox"] + label {
    margin: 5px 0;
  }
  p,
  label span {
    line-height: 40px;
  }
  label {
    height: 40px;
  }

  input[type="checkbox"] + label::before {
    position: relative;
    width: 15px;
    height: 15px;
    margin-top: 5px;
    margin-left: 5px;
    border-radius: 2px;
    left: -5px;
    border: 2px solid #cf6e14;
    background-color: #fff;
    display: block;
    content: "";
    float: left;
    margin-right: 5px;
  }
  input[type="checkbox"]:checked + label::before {
    box-shadow: inset 0px 0px 0px 1px #fff;
    background-color: #e98120;
  }

  input[type="radio"] {
    display: none;
  }

  input[type="radio"] + label::before {
    width: 15px;
    height: 15px;
    border-radius: 15px;
    vertical-align: center;
    left: -5px;
    margin-top: 5px;
    margin-left: 5px;
    position: relative;
    background-color: #d1d3d1;
    content: "";
    display: block;
    float: left;

    visibility: visible;
    border: 2px solid white;
  }

  input[type="radio"]:checked + label::before {
    position: relative;
    background-color: #e98120;
    content: "";
    display: inline-block;
    visibility: visible;
    border: 2px solid white;
  }

  .mandatory-info {
    width: 100%;
    height: 40px;
    color: #888888;
  }

  .dropdown {
    width: 100%;
    height: 40px;
    padding-left: 10px;
    ${"" /* -webkit-appearance: none; */}
    border: 1px solid #888888;
    box-sizing: border-box;
    border-radius: 3px;
    display: flex;
    align-items: center;
    color: #888888;
    background: #ffffff;
  }

  /* checkbox container */
  .checkboxes {
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    flex-direction: column;
  }

  /* checkbox icon styling */

  /* checkboxes including text */
  .checkboxes p {
    width: 100%;
    height: 40px;
    font-family: Source Sans Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 23px;
    color: #141414;
  }

  /* form submit button */
  .checkboxes button {
    color: #ffffff;
    width: 100%;
    height: 60px;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0) 100%
      ),
      #cf6e14;
    border: 2px solid #d5e3fb;
    box-sizing: border-box;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 3px;
    &:hover {
      background-color: ${props => props.theme.blockCTAHover};
      border: 2px solid #d6300a;
    }
  }
`

export default DynamicContactForm
